export const LOOKUP_CONFIG_LOCALE_ZHCHT = {
    placeholder: 'é¸æè¡¨å®åæ¸æ',
    code: 'ç·¨è',
    name: 'åç¨±',
    select: 'é¸æå¹«å©åæ¸æ',
    filter: 'éç½®æ¢ä»¶',
    helpidEmpty: 'helpIdä¸è½çºç©º',
    selectTitle: 'å¹«å©åæ¸æé¸æ',
    lookupTitle: 'å¹«å©éç½®',
    sure: 'ç¢ºå®',
    cancel: 'åæ¶',
    successSave: 'ä¿å­æå',
    helpIdError: 'è«é¸æå¹«å©åæ¸æ',
    fileNamePlaceholder: 'é¸æå¹«å©ææ¬å­æ®µ',
    selectFileNameTitle: 'ææ¬å­æ®µé¸æå¨',
    bindingPath: 'ç¶å®å­æ®µ',
    fieldError: 'å·²ç¶å®å­æ®µä¸å­å¨ï¼',
    textFieldLable: 'å¹«å©ææ¬å­æ®µ',
    loadTypeTitle: 'é¸æå è¼æ¹å¼',
    loadTypeList: {
        all: 'å¨é¨å è¼',
        layer: 'åå±¤å è¼',
        default: 'é»èª'
    },
    powerTitle: 'æ¬éè¨­ç½®',
    powerObjLabel: 'æ¬éå°è±¡',
    powerFieldLabel: 'æ¬éå­æ®µ',
    powerOperateLabel: 'æ¬éæä½',
    linkfieldLabel: 'å¹«å©éè¯å­æ®µ',
    powerDataTitle: 'æ¬éå°è±¡é¸æ',
    powerFieldTitle: 'æ¬éå­æ®µé¸æ',
    powerOperateTitle: 'æä½é¸æ',
    businessLable: 'æ¥­åå°è±¡',
    powerLable: 'æ¬éå°è±¡',
    powerError: 'è«é¸ææ¬éå°è±¡',
    operateError: 'è«é¸ææä½',
    linkfieldError: 'è«é¸ææ¬éå­æ®µ'
};
